// import React, { useState } from 'react';
// import './ZooList.css'; // ไฟล์ CSS สำหรับการจัดรูปแบบ
// import kk from '../img/KK-zoo.png';
// import cm from '../img/CM-zoo.png';
// import kn from '../img/KN-zoo.png';
// import nm from '../img/NM-zoo.png';
// import sk from '../img/SK-zoo.png';
// import ub from '../img/UB-zoo.png';

// import Navbar from '../navbarv2/navbar';
// import Footer from '../navbarv2/footer';

// import ubon001 from '../imzoopage/ubon01.png';
// import ubon002 from '../imzoopage/ubon002.png';

// import kk001 from '../imzoopage/kk001.png';
// import kk002 from '../imzoopage/kk002.png';

// import korat01 from '../imzoopage/korat01.jpg';
// import korat02 from '../imzoopage/korat02.jpg';


// import sk001 from '../imzoopage/sk01.jpg';
// import sk002 from '../imzoopage/sk002.jpg';

// import kn001 from '../imzoopage/kn001.jpg';
// import kn002 from '../imzoopage/kn002.jpg';

// import cm001 from '../imzoopage/cm001.jpg';
// import cm002 from '../imzoopage/cm002.jpg';
// // ข้อมูลสวนสัตว์
// const zooPages = [ 
//     {logo: kk, sheet: kk001, show_time: kk002, name: "สวนสัตว์เปิดเขาเขียว", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkkopenzoo&tabs=timeline&width=1000&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233" },
//     {logo: ub, sheet: ubon001, show_time: ubon002, name: "สวนสัตว์อุบลราชธานี", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Feduubonzoo&tabs=timeline&width=1000&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233" },
//     {logo: cm, sheet: cm001, show_time: cm002, name: "สวนสัตว์เชียงใหม่", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FFanpageChiangMaiZoo&tabs=timeline&width=1000&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233" },
//     {logo: nm, sheet: korat01, show_time: korat02, name: "สวนสัตว์นครราชสีมา", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FNakhonratchasimaZoo&tabs=timeline&width=1000&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233" },
//     {logo: kn, sheet: kn001, show_time: kn002, name: "สวนสัตว์ขอนแก่น", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FKhonkaenzoo&tabs=timeline&width=1000&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233" },
//     {logo: sk, sheet: sk001, show_time: sk002, name: "สวนสัตว์สงขลา", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FSongkhlaZooPage&tabs=timeline&width=1000&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=404165548973233" }
// ];

// const ZooList = () => {
//     const [selectedZoo, setSelectedZoo] = useState(zooPages[0]); // เลือกสวนสัตว์แรกเป็นค่าเริ่มต้น

//     return (
//         <>
//         <Navbar></Navbar>
//         <div className="container">
//             <div className="row">
//                 <div className="col-md-4">
//                     <div className="list-group">
//                         {zooPages.map(zoo => (
//                             <button
//                                 key={zoo.name}
//                                 type="button"
//                                 className={`list-group-item list-group-item-action ${selectedZoo.name === zoo.name ? 'active' : ''}`}
//                                 onClick={() => setSelectedZoo(zoo)}
//                             >
//                                 <img src={zoo.logo} alt={`${zoo.name} Logo`} className="img-thumbnail me-2" style={{ width: '50px', height: '50px' }} />
//                                 {zoo.name}
//                             </button>
//                         ))}
//                     </div>
//                     <div className="embed-responsive embed-responsive-16by9">
//                         <iframe
//                             src={selectedZoo.url}
//                             width="100%"
//                             height="600"
//                             style={{ border: 'none' }}
//                             scrolling="no"
//                             frameBorder="0"
//                             allowFullScreen
//                             title={`Facebook Page - ${selectedZoo.name}`}
//                         ></iframe>
//                     </div>
//                 </div>
//                 <div className="col-md-8">
//                     <div className='col-md-12'>
//                     <img src={selectedZoo.sheet} alt="Sheet" className="img-fluid my-3" style={{ height: 'auto', width: 'auto' }} />

//                     </div>
//                     <div className='col-md-12'>
//                     <img src={selectedZoo.show_time} alt="Show Time" className="img-fluid my-3" style={{ height: 'auto', width: 'auto' }} />
//                     </div>



//                 </div>
//             </div>
//         </div>
//         <Footer></Footer>
//         </>

//     );
// };

// export default ZooList;



import React, { useState } from 'react';
import kk from '../img/KK-zoo.png';
import cm from '../img/CM-zoo.png';
import kn from '../img/KN-zoo.png';
import nm from '../img/NM-zoo.png';
import sk from '../img/SK-zoo.png';
import ub from '../img/UB-zoo.png';

import Navbar from '../navbarv2/navbar';
import Footer from '../navbarv2/footer';

import ubon001 from '../imzoopage/ubon01.png';
import ubon002 from '../imzoopage/ubon002.png';
import kk001 from '../imzoopage/kk001.png';
import kk002 from '../imzoopage/kk002.png';
import korat01 from '../imzoopage/korat01.jpg';
import korat02 from '../imzoopage/korat02.jpg';
import sk001 from '../imzoopage/sk01.jpg';
import sk002 from '../imzoopage/sk002.jpg';
import kn001 from '../imzoopage/kn001.jpg';
import kn002 from '../imzoopage/kn002.jpg';
import cm001 from '../imzoopage/cm001.jpg';
import cm002 from '../imzoopage/cm002.jpg';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Outfit:wght@300;400;500;600&display=swap');

  .zoolist-page {
    min-height: 100vh;
    background: #0a1628;
    font-family: 'Outfit', sans-serif;
    color: #f1f5f9;
  }

  /* ── PAGE HEADER ── */
  .zoolist-header {
    padding: 56px 40px 40px;
    max-width: 1300px;
    margin: 0 auto;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .zoolist-eyebrow {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #22c55e;
    margin-bottom: 8px;
  }

  .zoolist-title {
    font-family: 'Playfair Display', serif;
    font-size: clamp(1.8rem, 3vw, 2.6rem);
    font-weight: 700;
    color: #f1f5f9;
    margin: 0;
  }

  /* ── MAIN LAYOUT ── */
  .zoolist-body {
    max-width: 1300px;
    margin: 0 auto;
    padding: 36px 40px 80px;
    display: grid;
    grid-template-columns: 300px 1fr;
    gap: 32px;
    align-items: start;
  }

  @media (max-width: 900px) {
    .zoolist-body {
      grid-template-columns: 1fr;
      padding: 24px 16px 60px;
    }
    .zoolist-header { padding: 36px 16px 28px; }
  }

  /* ── SIDEBAR ── */
  .zoolist-sidebar {
    position: sticky;
    top: 88px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .sidebar-label {
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #475569;
    padding: 0 4px;
  }

  .zoo-tab-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .zoo-tab {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 13px 16px;
    border-radius: 14px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
    cursor: pointer;
    transition: all 0.2s;
    text-align: left;
    font-family: 'Outfit', sans-serif;
  }

  .zoo-tab:hover {
    background: rgba(255,255,255,0.07);
    border-color: rgba(255,255,255,0.12);
  }

  .zoo-tab.active {
    background: rgba(34,197,94,0.1);
    border-color: rgba(34,197,94,0.3);
  }

  .zoo-tab-logo {
    width: 40px;
    height: 40px;
    object-fit: contain;
    border-radius: 10px;
    background: rgba(255,255,255,0.05);
    padding: 4px;
    flex-shrink: 0;
  }

  .zoo-tab-name {
    font-size: 0.9rem;
    font-weight: 500;
    color: #94a3b8;
    flex: 1;
    transition: color 0.2s;
  }

  .zoo-tab.active .zoo-tab-name { color: #22c55e; }
  .zoo-tab:hover .zoo-tab-name { color: #f1f5f9; }

  .zoo-tab-arrow {
    font-size: 0.75rem;
    color: #334155;
    transition: color 0.2s, transform 0.2s;
  }
  .zoo-tab.active .zoo-tab-arrow { color: #22c55e; transform: translateX(2px); }

  /* FACEBOOK EMBED */
  .sidebar-fb-card {
    background: rgba(15,23,42,0.8);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 16px;
    overflow: hidden;
  }

  .sidebar-fb-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 16px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .sidebar-fb-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #1877f2;
  }

  .sidebar-fb-label {
    font-size: 0.78rem;
    font-weight: 500;
    color: #64748b;
  }

  .sidebar-fb-card iframe {
    display: block;
    width: 100%;
    border: none;
  }

  /* ── CONTENT AREA ── */
  .zoolist-content {
    display: flex;
    flex-direction: column;
    gap: 28px;
  }

  /* SELECTED ZOO HEADER */
  .zoo-content-header {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 28px 32px;
    background: rgba(15,23,42,0.7);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 20px;
    backdrop-filter: blur(12px);
  }

  .zoo-content-logo {
    width: 64px;
    height: 64px;
    object-fit: contain;
    border-radius: 14px;
    background: rgba(255,255,255,0.05);
    padding: 8px;
    border: 1px solid rgba(255,255,255,0.08);
    flex-shrink: 0;
  }

  .zoo-content-title {
    font-family: 'Playfair Display', serif;
    font-size: 1.6rem;
    font-weight: 700;
    color: #f1f5f9;
    margin: 0 0 4px;
  }

  .zoo-content-sub {
    font-size: 0.8rem;
    color: #475569;
    margin: 0;
  }

  /* IMAGE PANELS */
  .zoo-panels {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 700px) {
    .zoo-panels { grid-template-columns: 1fr; }
  }

  .zoo-panel {
    background: rgba(15,23,42,0.7);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 18px;
    overflow: hidden;
    transition: border-color 0.3s;
  }

  .zoo-panel:hover { border-color: rgba(34,197,94,0.2); }

  .zoo-panel-header {
    padding: 14px 18px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .zoo-panel-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #22c55e;
  }

  .zoo-panel-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #64748b;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .zoo-panel img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.4s ease;
  }

  .zoo-panel:hover img { transform: scale(1.01); }

  /* ANIMATE IN */
  .zoo-content-animate {
    animation: contentFadeIn 0.35s ease;
  }

  @keyframes contentFadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const zooPages = [
    { logo: kk, sheet: kk001, show_time: kk002, name: "สวนสัตว์เปิดเขาเขียว", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fkkopenzoo&tabs=timeline&width=300&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=404165548973233" },
    { logo: ub, sheet: ubon001, show_time: ubon002, name: "สวนสัตว์อุบลราชธานี", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Feduubonzoo&tabs=timeline&width=300&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=404165548973233" },
    { logo: cm, sheet: cm001, show_time: cm002, name: "สวนสัตว์เชียงใหม่", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FFanpageChiangMaiZoo&tabs=timeline&width=300&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=404165548973233" },
    { logo: nm, sheet: korat01, show_time: korat02, name: "สวนสัตว์นครราชสีมา", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FNakhonratchasimaZoo&tabs=timeline&width=300&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=404165548973233" },
    { logo: kn, sheet: kn001, show_time: kn002, name: "สวนสัตว์ขอนแก่น", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FKhonkaenzoo&tabs=timeline&width=300&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=404165548973233" },
    { logo: sk, sheet: sk001, show_time: sk002, name: "สวนสัตว์สงขลา", url: "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FSongkhlaZooPage&tabs=timeline&width=300&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=404165548973233" },
];

const ZooList = () => {
    const [selectedZoo, setSelectedZoo] = useState(zooPages[0]);
    const [animKey, setAnimKey] = useState(0);

    const handleSelect = (zoo) => {
        setSelectedZoo(zoo);
        setAnimKey(k => k + 1);
    };

    return (
        <>
            <style>{styles}</style>
            <div className="zoolist-page">
                <Navbar />

                {/* PAGE HEADER */}
                <div className="zoolist-header">
                    <div className="zoolist-eyebrow">รอบการแสดง &amp; กิจกรรม</div>
                    <h1 className="zoolist-title">องค์การสวนสัตว์
                        แห่งประเทศไทย</h1>
                </div>

                {/* BODY */}
                <div className="zoolist-body">

                    {/* SIDEBAR */}
                    <aside className="zoolist-sidebar">
                        <div className="sidebar-label">เลือกสวนสัตว์</div>

                        <div className="zoo-tab-list">
                            {zooPages.map(zoo => (
                                <button
                                    key={zoo.name}
                                    className={`zoo-tab${selectedZoo.name === zoo.name ? ' active' : ''}`}
                                    onClick={() => handleSelect(zoo)}
                                >
                                    <img src={zoo.logo} alt={zoo.name} className="zoo-tab-logo" />
                                    <span className="zoo-tab-name">{zoo.name}</span>
                                    <span className="zoo-tab-arrow">›</span>
                                </button>
                            ))}
                        </div>

                        {/* FACEBOOK FEED */}
                        {/* <div className="sidebar-fb-card">
              <div className="sidebar-fb-header">
                <div className="sidebar-fb-dot" />
                <span className="sidebar-fb-label">Facebook — {selectedZoo.name}</span>
              </div>
              <iframe
                key={selectedZoo.name}
                src={selectedZoo.url}
                height="500"
                scrolling="no"
                frameBorder="0"
                allowFullScreen
                title={`Facebook - ${selectedZoo.name}`}
              />
            </div> */}
                    </aside>

                    {/* CONTENT */}
                    <div className="zoolist-content">
                        <div key={animKey} className="zoo-content-animate">

                            {/* ZOO TITLE BAR */}
                            <div className="zoo-content-header">
                                <img src={selectedZoo.logo} alt={selectedZoo.name} className="zoo-content-logo" />
                                <div>
                                    <h2 className="zoo-content-title">{selectedZoo.name}</h2>
                                    <p className="zoo-content-sub">ตารางการแสดง &amp; กิจกรรมประจำวัน</p>
                                </div>
                            </div>

                            {/* IMAGE PANELS */}
                            <div className="zoo-panels">
                                <div className="zoo-panel">
                                    <div className="zoo-panel-header">
                                        <div className="zoo-panel-dot" />
                                        <span className="zoo-panel-label">ตารางกิจกรรม</span>
                                    </div>
                                    <img src={selectedZoo.sheet} alt="ตารางกิจกรรม" />
                                </div>

                                <div className="zoo-panel">
                                    <div className="zoo-panel-header">
                                        <div className="zoo-panel-dot" />
                                        <span className="zoo-panel-label">รอบการแสดง</span>
                                    </div>
                                    <img src={selectedZoo.show_time} alt="รอบการแสดง" />
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <Footer />
            </div>
        </>
    );
};

export default ZooList;